<template>
  <div class="page-form">
    <div class="tools">
      <el-button type="defualt" size="medium">提交</el-button>
      <el-button type="primary" size="medium">保存</el-button>
      
    </div>

    <h3 class="title">批条酒下单</h3>

    <div class="form-container">
      <el-form inline size="small" label-width="100px" :model="conditions" :rules="rules">
        <el-row :gutter="20">
          <el-col v-for="item in 11" :key="item" :span="8">
            <el-form-item label="商品编码">
              <el-select />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon
        title="明细信息"
        :pagination="pagination"
        @pagination-change="handleTablePaginationChange"
        @exportExcel="exportExcel"
      >
        <template #button>
          <table-button name="rest@3x" tip="增加" @click="tableEvent('add')" />
          <table-button name="rest@3x" tip="删除" @click="tableEvent('del')" />
          <table-button v-for="btn in gridOptions.buttons" :key="btn.label" name="rest@3x" :tip="btn.label" @click="tableEvent(btn)" />
        </template>
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          max-height="500"
          align="center"
          size="small"
          :empty-render="{name: 'NotData'}"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        >
          <!-- <template #toolbar /> -->
        </vxe-grid>
      </TableCommon>
    </div>
  </div>
</template>

<script>
import TableCommon from '@/components/TableCommon/index'
import TableButton from '@/components/TableButton/index'

export default {
  components: {
    TableCommon,
    TableButton
  },
  data() {
    return {
      gridOptions: {
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 50, align: 'center' },
          { field: 'PRODUCT_ID', title: '产品标识', width: 180, slots: { default: 'PRODUCT_ID' }},
          { field: 'SHORT_TEXT', title: '产品描述', width: 180 },
          { field: 'ZSALESUNIT', title: '营销单元', width: 180 },
          { field: 'PARTNER', title: '客户编号', width: 180 },
          { field: 'ZPRIC_TYPE', title: '价格类型', width: 180 },
          { field: 'KBETR', title: '价格金额', width: 180 },
          { field: 'RELEASE_STATUS', title: '发布状态', width: 180 },
          { field: 'ZINDEX', title: '生效节点', width: 180 },
          { field: 'TIMESTAMP_FROM', title: '有效日期起', width: 180 },
          { field: 'TIMESTAMP_TO', title: '有效日期截止', width: 180 }
        ],
        data: []
      },
      pagination: {
        page: 1,
        pagesize: 10,
        totalCount: 100
      }
    }
  },
  created() {
    for (let i = 0; i < 50; i++) {
      this.gridOptions.data.push({
        PRODUCT_ID: i
      })
    }
  },
  methods: {
    exportExcel(type) {},
    handleTablePaginationChange() {},
    toDetail() {
      this.$router.push('/test/detail')
    }
  }
}
</script>

<style lang='scss' scoped>

</style>



// WEBPACK FOOTER //
// src/views/TestDetail.vue